const updates = [
  {
    time: '15:32',
    title: '某女星被拍到与神秘男子同游日本，疑似新恋情曝光',
    tag: '恋情实锤',
    tagColor: 'primary',
  },
  {
    time: '14:18',
    title: '大热综艺节目录制中两位导师意见不合，现场火药味十足',
    tag: '综艺翻车',
    tagColor: 'accent',
  },
  {
    time: '13:05',
    title: '某顶流代言品牌突然更换代言人，背后原因引发猜测',
    tag: '合约风波',
    tagColor: 'primary',
  },
  {
    time: '11:42',
    title: '年度最受期待电影首支预告片意外泄露，片方紧急回应',
    tag: '影视剧透',
    tagColor: 'accent',
  },
  {
    time: '10:20',
    title: '知名歌手演唱会彩排视频流出，新歌舞台效果惊艳',
    tag: '音乐现场',
    tagColor: 'primary',
  },
  {
    time: '09:15',
    title: '某艺人凌晨直播情绪失控，粉丝担忧其心理健康状况',
    tag: '私生活',
    tagColor: 'accent',
  },
  {
    time: '08:00',
    title: '国际时装周中国艺人造型大盘点，谁成为全场焦点',
    tag: '红毯造型',
    tagColor: 'primary',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
              实时动态
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-foreground-600 text-sm max-w-lg mx-auto">
              按时间线追踪娱乐圈最新爆料，不错过任何一条热点
            </p>
          </div>

          <div className="max-w-2xl mx-auto">
            {updates.map((item, i) => (
              <div
                key={i}
                className="relative flex gap-5 pb-8 last:pb-0 group cursor-pointer"
              >
                {i < updates.length - 1 && (
                  <div className="absolute left-[19px] top-12 bottom-0 w-px bg-background-300"></div>
                )}

                <div className="relative z-10 flex-shrink-0 w-10 flex flex-col items-center">
                  <div className="w-[38px] h-[38px] flex items-center justify-center rounded-full bg-background-50 border-2 border-primary-200 group-hover:border-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200">
                    <i className="ri-flashlight-line text-sm"></i>
                  </div>
                </div>

                <div className="flex-1 min-w-0 pt-1">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-foreground-400 font-mono">{item.time}</span>
                    <span
                      className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                        item.tagColor === 'primary'
                          ? 'bg-primary-100 text-primary-700'
                          : 'bg-accent-100 text-accent-700'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}